import Debug from 'debug';
import * as React from 'react';
import { Button, FormControl, InputGroup, Stack } from 'react-bootstrap';
import InputGroupText from 'react-bootstrap/esm/InputGroupText';

const debug = Debug('gfe/fi/ColourPicker');

interface ColourPickerProps {
  className?: string;
  clearOnSelection?: boolean;
  editable: boolean;
  handleChange?: (newValue: string) => void;
  mandatory: boolean;
  validity?: boolean;
  value: string;
}

export const ColourPicker = (props: ColourPickerProps): React.JSX.Element => {
  const [activated, setActivated] = React.useState(false);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.handleChange) {
      props.handleChange(event.target.value);
    }
  };

  return (
    <Stack direction="horizontal" className={props.className}>
      {(props.mandatory || !!props.value || activated) && (
        <FormControl
          defaultValue={props.value}
          isInvalid={props.validity === false}
          isValid={props.validity === true}
          onChange={handleChange}
          disabled={!props.editable}
          type="color"
        />
      )}
      {!props.mandatory && !!props.value && (
        <Button
          variant="link"
          onClick={() => {
            props.handleChange?.('');
            setActivated(false);
          }}
        >
          Clear Selection
        </Button>
      )}
      {!props.mandatory && !props.value && !activated && (
        <>
          <span>No colour selected</span>
          <Button variant="link" onClick={() => setActivated(true)}>
            Choose a colour
          </Button>
        </>
      )}
    </Stack>
  );
};
